import React from "react"
import TransitionFade from "../../../transition-fade"
import NonStretchedImage from "../../../Image/non-stretched-image"
import {
  nePasManquerItem,
  nePasManquerItemDescription,
  nePasManquerItemImg,
  nePasManquerListItem,
  editButton,
} from "../ne-pas-manquer.module.scss"
import PropTypes from "prop-types"
import EditButton from "../../../EditButton/edit-button"

const NePasManquerItem = ({ nePasManquer }) => (
  <div role={"listitem"} className={nePasManquerListItem}>
    <EditButton
      addedClass={editButton}
      link={"/node/" + nePasManquer.drupal_internal__nid + "/edit"}
    />
    <TransitionFade link={nePasManquer.path.alias}>
      <div className={nePasManquerItem}>
        <NonStretchedImage
          className={nePasManquerItemImg}
          {...nePasManquer?.relationships?.field_image_page_de_base?.localFile}
          ariaHidden={true}
        />
        <h3 className={nePasManquerItemDescription}>{nePasManquer.title}</h3>
      </div>
    </TransitionFade>
  </div>
)

NePasManquerItem.propTypes = {
  nePasManquer: PropTypes.object.isRequired,
}

export default NePasManquerItem
